import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';

export const superAdminGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (auth.isAuthenticated()) {
    return auth.user()?.isSuperAdmin ? true : router.createUrlTree(['/dashboard']);
  }

  return auth
    .loadSession()
    .pipe(map((u) => (u?.isSuperAdmin ? true : router.createUrlTree(['/dashboard']))));
};
